<template>

<div>
    <h3 class="fieldset-title text-left mb-4">
        Вие сте подали оферта за участие
    </h3>
    <p>Параметрите на Вашата оферта:</p>

    <div class="offer-params row">

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Цена за изпълнението: 
                    <strong class="param-val"> {{ offer.cost }} лв. </strong>
                </span>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Срок за изпълнение:
                    <strong class="param-val"> {{ offer.time }} дни </strong>
                </span>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Такса за Видеа: 
                    <strong class="param-val"> {{ videaTax() }} лв. </strong>
                </span>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Крайна сума за вас: 
                    <strong class="param-val"> {{ offer.cost - videaTax() }} лв. </strong>
                </span>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Дата на подаване:
                    <strong class="param-val"> {{ offer.created_at }} </strong>
                </span>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                <span class="count-offers">
                    Рейтинг на изпълнителя: 
                    <strong class="param-val"> {{ offer.rating }} </strong>
                </span>
            </div>
        </div>
    
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        props : ['offer'],

        data() {
            return {
                isReady : false,
            }
        },

        methods : {
            videaTax() {
                var min = this.$store.state.coefs.mt;
                var per = Math.ceil( this.offer.cost * this.$store.state.coefs.tp / 100 );
                
                if( min > per ) {
                    return min;
                } else {
                    return per;
                }
            }
        }

    }
</script>
